import { jsxs as i, jsx as l } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    children: [
      /* @__PURE__ */ i("g", { clipPath: "url(#clip0_7543_180567)", children: [
        /* @__PURE__ */ l("rect", { width: "100", height: "100", rx: "50", fill: "#676DFD" }),
        /* @__PURE__ */ l("rect", { width: "100", height: "100", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38.8892 26.7852C37.903 26.7852 37.1035 27.5846 37.1035 28.5709V58.5312C37.1035 59.5174 37.903 60.3169 38.8892 60.3169H56.1418L67.206 68.3276C67.5602 68.584 68.0559 68.331 68.0559 67.8937V60.3169H71.4289C72.4151 60.3169 73.2146 59.5174 73.2146 58.5312V28.5709C73.2146 27.5846 72.4151 26.7852 71.4289 26.7852H38.8892Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M37.1027 37.1035V58.532C37.1027 59.5182 37.9022 60.3177 38.8884 60.3177H56.141L57.7375 61.4736V71.4289C57.7375 72.4151 56.938 73.2146 55.9518 73.2146H28.5709C27.5846 73.2146 26.7852 72.4151 26.7852 71.4289V38.8892C26.7852 37.903 27.5846 37.1035 28.5709 37.1035H37.1027Z",
            fill: "#676DFD"
          }
        ),
        /* @__PURE__ */ l("path", { d: "M42.2615 36.7802H68.0551V34.8457H42.2615V36.7802Z", fill: "#49565D" }),
        /* @__PURE__ */ l("path", { d: "M52.5788 41.939H44.8407V40.0045H52.5788V41.939Z", fill: "#49565D" }),
        /* @__PURE__ */ l("path", { d: "M68.0551 41.939H55.1583V40.0045H68.0551V41.939Z", fill: "#49565D" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M68.0551 67.8937C68.0551 68.331 67.5594 68.584 67.2052 68.3276L57.7375 61.4728V71.4281C57.7375 72.4143 56.938 73.2138 55.9518 73.2138H28.5709C27.5846 73.2138 26.7852 72.4143 26.7852 71.4281V38.8884C26.7852 37.9022 27.5846 37.1027 28.5709 37.1027H37.1027V28.5709C37.1027 27.5846 37.9022 26.7852 38.8884 26.7852H71.4281C72.4143 26.7852 73.2138 27.5846 73.2138 28.5709V58.5312C73.2138 59.5174 72.4143 60.3169 71.4281 60.3169H68.0551V67.8937ZM56.7196 58.5312L66.2694 65.4454V58.5312H71.4281V28.5709L38.8884 28.5709V58.5312H56.7196ZM37.1027 38.8884H28.5709V71.4281H55.9518V60.3169H38.8884C37.9022 60.3169 37.1027 59.5174 37.1027 58.5312V38.8884Z",
            fill: "#49565D"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_7543_180567", children: /* @__PURE__ */ l("rect", { width: "100", height: "100", rx: "50", fill: "white" }) }) })
    ]
  }
);
export {
  t as CommentsIllustration
};
//# sourceMappingURL=index.es501.js.map
